import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { UntilDestroy } from "@ngneat/until-destroy";
import { Store } from "@ngxs/store";
import { PermitPersonWithStatus } from "../../../shared/models/permit-person.model";
import { AddPersonModalComponentData } from "../add-person-modal/interface/add-person-modal-component-data";
import { PermitTeamActions } from "../../states/permit-team.action";

@UntilDestroy()
@Component({
    selector: "pmt-create-team-member-text-field",
    templateUrl: "create-team-member-text-field.component.html",
    styleUrls: ["create-team-member-text-field.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateTeamMemberTextField implements OnInit, OnDestroy {
    public form: UntypedFormGroup;
    public data: AddPersonModalComponentData;

    @Output() createCertificateEvent1 = new EventEmitter<PermitPersonWithStatus>();
    
    @Input() 
    public permitId: number;
    
    constructor(
        private fb: UntypedFormBuilder,
        private store: Store,
    ) {
        this.createForm();
    }

    private createForm() {
                this.form = this.fb.group({
                    member: [{ value: "", disabled: false }, [
                        Validators.required,
                        Validators.minLength(2),
                    ]],
                });
        }

    public ngOnInit() {
            this.createForm();
        }

    public ngOnDestroy(): void {
    }

    public createTeamMember() {
            if (this.form.valid) {
                const member = this.form.get('member')?.value;
                this.form.get('member')?.reset();

                this.store.dispatch(new PermitTeamActions.CreatePermitTeamTextMember(this.permitId, member));
            } else {
                this.form.markAsDirty();
            }
        }

    public submitCreateCertificate() {
        }


}